import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/common/Layout'
import Notfound from './components/common/Notfound'
import About from './overlayContent/About'
import Work from './overlayContent/Work'
import Contact from './overlayContent/Contact'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Layout />}>
            {/* <Route index element={<PageLoader />} /> */}
            {/* 중첩된 라우트 설정 */}
            {/* <Route path="about" />
            <Route path="work" />
            <Route path="contact" /> */}
          </Route>
          <Route path="*" element={<Notfound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
